<template>
  <div>
    <v-breadcrumbs class="systock-breadcrump" dark>
      <v-breadcrumbs-item>Gerenciamento de Grupos e Filiais</v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-card flat>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-account-group</v-icon>
          Grupos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-home-group</v-icon>
          Grupo Filial
        </v-tab>

        <v-tab-item>
          <cfg-grupos @novoGrupo="grupo = $event" class="mx-1"></cfg-grupos>
        </v-tab-item>

        <v-tab-item>
          <cfg-grupo-filial :atualizarGrupoFilial="grupo" class="mx-1"></cfg-grupo-filial>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>

import CfgGrupos from "./../cfg/CfgGrupos.vue";
import CfgGrupoFilial from "./../cfg/CfgGrupoFilial.vue";


export default {
  components: {
    CfgGrupos,
    CfgGrupoFilial,
  },
  name: "Cfg",

  data() {
    return {
      comprador: 0,
      grupo: 0,
    };
  },

  created() {
    this.Helpers.verificarToken();
  },
};
</script>
<style>
.altura-tabela .v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
}
</style>
